<template>
  <section id="how-we-curate" class="curate" aria-labelledby="curate-title">
    <div class="curate__inner">
      <div class="curate__intro">
        <p class="eyebrow">How we curate</p>
        <h2 id="curate-title">Chosen by hand, <em>made to last.</em></h2>
      </div>

      <ol class="curate__list">
        <li v-for="(point, i) in points" :key="point.title">
          <span class="curate__num">{{ numerals[i] }}</span>
          <h3>{{ point.title }}</h3>
          <p>{{ point.body }}</p>
        </li>
      </ol>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HowWeCurate',

  data() {
    return {
      numerals: ['I', 'II', 'III', 'IV'],
      points: [
        { title: 'One of a kind', body: 'Every piece is unique. Once it’s gone, there will never be another quite like it.' },
        { title: 'Never printed, always human', body: 'Hand-painted canvases, hand-thrown ceramics and hand-woven rugs. Made by people, never by a printer.' },
        { title: 'Support local artists', body: 'We work directly with artists in our community, so your purchase goes to the maker.' },
        { title: 'Fairly priced', body: 'Real art shouldn’t cost a fortune. We price to be lived with, not locked away.' },
      ],
    }
  },
}
</script>

<style scoped>
.curate {
  border-top: 1px solid var(--linen);
  padding: 10rem 4rem;
  scroll-margin-top: 10rem;
}

.curate__inner {
  max-width: var(--max-w);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 2fr);
  gap: 6.4rem;
}

.curate__intro h2 {
  font-size: clamp(3.4rem, 4vw, 4.8rem);
  font-weight: 400;
  line-height: 1.1;
  margin-top: 1.2rem;
}

.curate__intro em { color: var(--amber); }

.curate__list {
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4.8rem 4rem;
}

.curate__num {
  display: block;
  font-family: var(--font-display);
  font-style: italic;
  font-size: 2rem;
  color: var(--amber);
  margin-bottom: 1.2rem;
}

.curate__list h3 {
  font-size: 2.6rem;
  font-weight: 500;
  margin-bottom: 0.8rem;
}

.curate__list p {
  font-size: 1.5rem;
  font-weight: 300;
  line-height: 1.7;
  color: var(--charcoal);
}

@media (max-width: 960px) {
  .curate { padding: 6.4rem 1.6rem; }
  .curate__inner { grid-template-columns: 1fr; gap: 4rem; }
}

@media (max-width: 640px) {
  .curate__list { grid-template-columns: 1fr; gap: 3.2rem; }
}
</style>
